module.exports = __webpack_public_path__ + "static/media/Մարիետա-Բադալյան-Ռոմանոս-Մելիքյան-Վարդը.98275224.mp3";